import {
    GET_AD_TARGETING_PARAMETERS
} from '../actions/adTargetingParameterActions';

const initialState = {
};

export function adTargetingParameters(state = initialState, action)
{
    switch (action.type)
    {
        case GET_AD_TARGETING_PARAMETERS.pending:
        {
            return {
                ...state,
                parametersIsFetching: true
            };
        }
        case GET_AD_TARGETING_PARAMETERS.fulfilled:
        {
            return {
                ...state,
                targetingParameters: action.payload,
                lastError: {},
                parametersIsFetching: false
            };
        }

        case GET_AD_TARGETING_PARAMETERS.rejected:
        {
            return {
                ...state,
                targetingParameters: undefined,
                lastError: action.payload,
                parametersIsFetching: false
            };
        }
        default:
            return state;

    }
}
